import Navbar from "../../commonComponents/Navbar";
import CheckInBanner from "../../Componentsss/WebCheckIn/CheckInBanner";
import Footer from "../../commonComponents/Footer";
import React, { lazy, Suspense } from "react";
const FlightCheckIn = lazy(() =>
  import("../../Componentsss/WebCheckIn/FlightCheckIn")
);
const BenefitCheckIn = lazy(() =>
  import("../../Componentsss/WebCheckIn/BenefitCheckIn")
);
const WebCheckIn = () => {
  return (
    <>
      <Navbar />
      <CheckInBanner />
      <Suspense fallback={<div>Loading sections...</div>}>
        <FlightCheckIn />
        <BenefitCheckIn />
      </Suspense>
      <Footer />
    </>
  );
};

export default WebCheckIn;
